// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"299":"6d5b5cd3","520":"d4437dc5"}[chunkId] + ".chunk.css";
};